"use client";

import { cn } from "@/lib/utils";

interface LiveIconProps {
    className?: string;
}

export function LiveIcon( { className }: LiveIconProps ) {
    return (
        <div
            className={cn(
                "animate-live-pulse size-4 bg-state-danger rounded flex items-end justify-center gap-0.5 px-0.5 py-1 overflow-hidden",
                className,
            )}
        >
            <div
                className="w-0.5 bg-content-fixed-inverse animate-live-bar"
                style={{ height: "7px", animationDelay: "0s" }}
            />
            <div
                className="w-0.5 bg-content-fixed-inverse animate-live-bar"
                style={{ height: "7px", animationDelay: "-0.3s" }}
            />
            <div
                className="w-0.5 bg-content-fixed-inverse animate-live-bar"
                style={{ height: "7px", animationDelay: "-0.1s" }}
            />
        </div>
    );
}
